import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-training-challenge-form',
  templateUrl: './training-challenge-form.component.html',
  styleUrls: ['./training-challenge-form.component.scss']
})
export class TrainingChallengeFormComponent {
  @Input() enablementChallengeForm!: FormGroup;
  @Input() allUsers: any[] = [];
  @Input() challengeParticipantFlag: boolean = false;
  @Input() enablementWinnersOptions: any[] = [];
  @Input() totalCompanyCreditsAvailable: any;
  @Input() trainingTicketError: string = '';
  @Input() errMessages: any = {};
  @Input() minDate: any;
  @Input() minEndDate: any;
  @Input() maxDate: any;
  @Input() updateFlag: boolean = false;
  @Input() isLearningMapsReady: boolean = false;
  @Input() isLearningCoursesReady: boolean = false;
  @Input() learningMapsCourses: any[] = [];
  @Input() selectedLearningMapsCourses: any[] = [];
  @Input() isEnablementChallenge: boolean = false;

  @Output() ticketCalculation = new EventEmitter<void>();
  @Output() startDateChange = new EventEmitter<any>();
  @Output() resetForm = new EventEmitter<void>();
  @Output() postForm = new EventEmitter<boolean>();

  isEmptyEnablementUser(): boolean {
    if (!this.enablementChallengeForm) { return true; }
    const users = this.enablementChallengeForm.get('users');
    return !users || !users.value || users.value.length === 0;
  }
}
